import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/crm/Oportunidad/Create',
  alias: [],
  documento: 'crm',
  filas: ['135'],
  acceso: 'sesion',
  cita: 'prod:Areas/CRM/Controllers/OportunidadController.cs:245',
} satisfies RutaProd;
